import React from 'react'
import styles from './styles.module.scss'

interface FCAUpdateBoxProps {
    className?: string
}

const FCAUpdateBox: React.FC<FCAUpdateBoxProps> = ({ className = '' }) => {
    return (
        <div className={`${styles.fcaUpdateBox} ${className}`}>
            <div className={styles.criticalIcon}>
                <div className={styles.exclamationMark}>!</div>
            </div>
            <div className={styles.updateHeader}>
                <h3 className={styles.updateTitle}>FCA Redress Scheme Consultation Update</h3>
            </div>
            <div className={styles.updateContent}>
                <p className={styles.updateText}>
                    The Financial Conduct Authority (FCA) is currently consulting on proposals for a motor finance
                    redress scheme. This consultation will consider how compensation should be calculated and whether
                    claims could be resolved without the need to involve law firms.
                </p>
                <p className={styles.updateText}>
                    We continue to monitor the process closely and remain committed to supporting consumers in achieving
                    fair outcomes.
                </p>
            </div>
        </div>
    )
}

export default FCAUpdateBox
